<template>
  <div class="test">
    <div class="wrapper">
      <h2>Тестовое задание от Транскапиталбанк</h2>

      <div class="tkb">

        <div class="tkb__name">Задание:</div>

        <ol class="tkb__tasks">
          <li class="tkb__tasks-item">
            Сверстать страницу, в которой расположена таблица с возможность ввода данных. Столбцы таблицы:
            <ul class="tkb__points">
              <li class="tkb__points-item">ФИО</li>
              <li class="tkb__points-item">Должность (выбор из списка: аналитик, менеджер, программист, юрист)</li>
              <li class="tkb__points-item">Возраст</li>
              <li class="tkb__points-item">Компетенции (свободное заполнение)</li>
            </ul>
            <p class="tkb__p">Желательно при верстке применять методологию БЭМ. Плюсом будет использование CSS Grid.</p>
            <p class="tkb__p"><u>Схематичный макет страницы</u>:</p>
            <div class="tkb__scheme">
              <img src="../../assets/tests/tkb/scheme.jpg" alt="" class="tkb__scheme-img">
            </div>
          </li>

          <li class="tkb__tasks-item">
            Добавить интерактивность форме:
            <ul class="tkb__points">
              <li class="tkb__points-item">Добавление новой строки таблицы</li>
              <li class="tkb__points-item">Удаление строк таблицы</li>
              <li class="tkb__points-item">Валидация заполнения полей</li>
              <li class="tkb__points-item">Обработчик кнопки «Отправить»: сформировать объект содержащий данные из формы, преобразовать его в json и вывести в консоль</li>
            </ul>
          </li>

          <li class="tkb__tasks-item">
            <b>Дополнительно:</b> Разработать php скрипт, который будет получать сформированный json и преобразовать его в массив. Если преобразование пройдет удачно, вернуть булевое значение true. В случае ошибки – false.
          </li>
        </ol>

        <div class="tkb__result"><a href="/test/tkb/index.html" title="" target="_blank">Итог выполнения</a></div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "tkb",

  data () {
    return {

    }
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .test {
    position: relative;
    margin: 30px 0 0;
  }

  .tkb {
    position: relative;

    &__name {
      margin: 20px 0 0;
      text-align: center;
      font-size: 16px;
      font-weight: bold;

      @media screen and (min-width: 768px){
        text-align: left;
      }
    }

    &__p {
      margin: 15px 0 0;
      padding: 0;
    }

    &__tasks {
      margin: 0;
      padding: 0 0 0 20px;

      &-item {
        margin: 20px 0 0;
        padding: 0;
      }
    }

    &__points {
      list-style: disc;
      margin: 0;
      padding: 0 0 0 20px;

      &-item {
        margin: 3px 0 0;
        padding: 0;
      }
    }

    &__scheme {
      margin: 15px 0 0;

      &-img {
        max-width: 100%;
      }
    }

    &__result {
      margin: 20px 0 0;
      text-align: center;

      @media screen and (min-width: 768px){
        text-align: left;
      }
    }
  }

</style>
